import { useCallback } from "react";
import { dispatcher } from "../store";
import { useStoreSelector } from "./redux/useStoreSelector";
import { useNotify } from "./system/useNotify";
import { useApi } from "./useApi";


export function useEquity() {
  const {api, isAuth} = useApi(),
    equity = useStoreSelector( s => s.equity),
    {handleApiError} = useNotify()

  const loadEquity = useCallback((id: number) => {
    if (isAuth) {
      api.getPortfoliosByIdPositionEquity({id})
        .then(handleApiError)
        .then((body) => {
          if (body) {
            if (body["client_portfolio"]) {
              dispatcher.equity.setClientPortfolio(body["client_portfolio"]);
            } else {
              dispatcher.equity.unsetClientPortfolio();
            }
            if (body["client_cash_portfolio"]) {
              dispatcher.equity.setClientCashPortfolio(body["client_cash_portfolio"]);
            } else {
              dispatcher.equity.unsetClientCashPortfolio();
            }
            if (body["client_margin_portfolio"]) {
              dispatcher.equity.setClientMarginPortfolio(body["client_margin_portfolio"]);
            } else {
              dispatcher.equity.unsetClientMarginPortfolio();
            }
          }
        })
        .catch(console.error)
    }
  }, [api, handleApiError, isAuth])

  return {equity, loadEquity}
}
